<template>
    <section class="bg-black text-white p-3 lg:p-0 pb-20">
        <div class="flex flex-col lg:flex-row lg:justify-between lg:items-center lg:px-12">
            <h2 class="text-2xl">{{ $t('video.allVideos') }}</h2>
            <div class="my-8 lg:my-0 flex justify-between items-center gap-6">
                <div>
                    <label for="year-select">{{ $t('video.year') }}</label>
                </div>

                <div class="flex-1">
                    <MoleculeSelectInput class="!border-darkgray" id="year-select" name="year" v-model="selectedYear" :options="yearOptions" />
                </div>
            </div>
        </div>
        <div class="h-[1px] w-full bg-white my-8"></div>

        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-8 lg:px-12 pb-32">
            <MoleculeVideosCard v-for="video in renderVideos" :key="`all-videos-${video.id}`" :video="video" />
        </div>
    </section>
</template>

<script>
import AtomCarouselLoadingBar from "../../global/atoms/AtomCarouselLoadingBar.vue";
import MoleculeVideosCard from "../../videos/molecules/MoleculeVideosCard.vue";
import MoleculeSelectInput from "../../global/molecules/MoleculeSelectInput.vue";
import { mapState } from "vuex";
import _ from "lodash";

export default {
    name: "OrganismVideosAllVideos",
    components: {
        MoleculeSelectInput,
        MoleculeVideosCard,
        AtomCarouselLoadingBar
    },
    data() {
        return {
            selectedYear: null,
            page: 1,
        };
    },
    computed: {
        ...mapState("video", {
            videos: "videos",
        }),
        // Group videos by year
        groupedVideos() {
            const grouped = {};

            // Iterate through videos and group them by year
            this.videos.forEach((video) => {
                const year = new Date(video.starting_date).getFullYear();
                if (!grouped[year]) {
                    grouped[year] = [];
                }
                grouped[year].push(video);
            });

            return grouped;
        },
        renderVideos() {
            const selectedYear = this.selectedYear;

            if (selectedYear) {
                if (this.groupedVideos[selectedYear]) {
                    return this.groupedVideos[selectedYear].slice(0, this.page * 16);
                } else {
                    return [];
                }
            }

            return Object.values(this.groupedVideos).flat().sort((a,b) => new Date(b.starting_date) - new Date(a.starting_date));
        },
        yearOptions() {
            return Object.keys(this.groupedVideos).reverse();
        },
    },
    watch:{
        selectedYear: function (){
            this.page = 1
        }
    },
    methods: {
        handleScroll: _.debounce(function () {
            // Check if you are at the bottom of the page
            if (window.scrollY + window.innerHeight + 800 >= document.body.scrollHeight) {
                this.page++;
            }
        }, 200),
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
};
</script>

